import { css } from '@emotion/react';
import format from 'date-fns/format';
import { useDropdown } from 'hooks/useDropdown';
import React, { ReactNode, useRef } from 'react';
import { DropdownItemStyle } from 'styles/DropdownItemStyle';
import { DropdownStyle } from 'styles/DropdownStyle';

const months = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

export const MonthPicker = ({
	children,
	handleClick,
	date,
	renderTrigger,
}: {
	children?: ReactNode;
	handleClick: (index: number, toggleDropdown: any) => void;
	date: Date;
	renderTrigger: ({ isOpen }: { isOpen?: boolean }) => ReactNode;
}) => {
	const dropdownRef = useRef(null);
	const [open, toggleDropdown] = useDropdown(dropdownRef);

	const monthsHalf = [...months];
	const monthsRest = monthsHalf.splice(6);

	const trigger = renderTrigger?.({ isOpen: open });

	return (
		<div
			ref={dropdownRef}
			css={css`
				position: relative;
			`}
		>
			<div
				onClick={() => {
					toggleDropdown();
				}}
				className={'open'}
			>
				{trigger}
				{children}
			</div>

			<div
				css={[
					DropdownStyle(),
					css`
						position: absolute;
						top: 100%;
						z-index: 10;
						min-width: 100%;

						font-size: 14px;
						font-weight: normal;
						display: flex;

						${!open &&
						css`
							display: none;
						`};
					`,
				]}
			>
				<div>
					{monthsHalf.map((month, index) => {
						return (
							<div
								key={index}
								css={[DropdownItemStyle({ active: index + 1 === parseInt(format(date, 'M')) })]}
								onClick={() => {
									handleClick(index, toggleDropdown);
									toggleDropdown();
								}}
							>
								{month}
							</div>
						);
					})}
				</div>

				<div>
					{monthsRest.map((month, index) => {
						const monthIndex = index + 6;
						return (
							<div
								key={monthIndex}
								css={[
									DropdownItemStyle({ active: monthIndex + 1 === parseInt(format(date, 'M')) }),
								]}
								onClick={() => {
									handleClick(monthIndex, toggleDropdown);
									toggleDropdown();
								}}
							>
								{month}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};
